import React, { useState, useEffect } from 'react'
import Quote from '../Quote/Quote';
// import Quotes from '../../../../backend/models/quotes';
import axios from 'axios';
import parrot from './parrot.json';
import Lottie from 'lottie-react';
import styles from '../Pages/AllQuotes.module.css'


const AllQuotes = () => {


    // const DUMMY_QUOTES = [
    //     {
    //         author: 'Mahatma Gandhi',
    //         text: 'A man is but the product of his thoughts. What he thinks, he becomes.'
    //     },
    //     {
    //         author: 'Mahatma Gandhi',
    //         text: 'The greatness of humanity is not in being human, but in being humane.'
    //     },
    //     {
    //         author: 'Nelson Mandela',
    //         text: "It always seems impossible until it's done."
    //     },
    //     {
    //         author: 'Abraham Lincoln',
    //         text: "Democracy is by the people, for the people, of the people."
    //     },
    // ]

    const [quotes, setQuotes] = useState([]);
    const [isLoading , setIsLoading] = useState(true);



    async function getAllQuotes() {
        try {
            const res = await axios.get('https://quotes-app-qrwa.onrender.com/allQuotes');
            // console.log(res.data);
            setQuotes(res.data);
            setIsLoading(false);

        }
        catch(e){
            console.log('cannot fetch the quotes at the moment');
        }
    }



    useEffect(() => {
        getAllQuotes();
    }, []);


    return (
        <div>
            <h1 style={{ textAlign: 'center', marginTop:'70px' , marginBottom:'30px'  }}>All QUOTES</h1>
            {isLoading ?
                // <p>Loading....</p> :
                <Lottie className={styles.parrot} animationData={parrot}/> :
                <ul style={{padding:'0px'}}>
                {
                    quotes.map((quote) => {
                        return <Quote
                            key={quote._id}
                            author={quote.author}
                            text={quote.text}
                            id={quote._id}
                        />
                    })
                }
            </ul>
            }
        </div>
    )
}

export default AllQuotes